"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

var _translation = require("@/mixins/translation/translation");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderDateRangeComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderDateRangeComponent, _Mixins);

  var _super = _createSuper(LMDOrderDateRangeComponent);

  function LMDOrderDateRangeComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDOrderDateRangeComponent);
    _this = _super.apply(this, arguments);
    _this.oldDateRange = null;
    return _this;
  }

  (0, _createClass2.default)(LMDOrderDateRangeComponent, [{
    key: "handleDateRangeChange",
    value: function handleDateRangeChange(newVal, oldVal) {
      this.oldDateRange = oldVal;
    }
  }, {
    key: "onDateRangeChanges",
    value: function () {
      var _onDateRangeChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newVal) {
        var p;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.updateEndDateTime(newVal, this.oldDateRange);

                if (this.isAutoAssign) {
                  _context.next = 12;
                  break;
                }

                p = _objectSpread({}, this.$defaultPagination);
                p.pageSize = this.$pagination['pageSize'];
                this.$setPagination(p);
                this.logger.info('handleAutoAssignNormal - Set pagination', JSON.stringify(this.$pagination));
                this.$setSelectedOrders([]);
                this.logger.info('onDateRangeChanges - Get Unassigned Orders');
                _context.next = 10;
                return this.$getUnassignedOrders();

              case 10:
                _context.next = 13;
                break;

              case 12:
                this.$resetPlan();

              case 13:
                this.$selectedLocation = null;
                this.$locationType = this.$defaultLocationType;
                this.$getOrderLocationLists({
                  locationType: this.$defaultLocationType,
                  startTime: this.$startDate,
                  endTime: this.$endDate
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDateRangeChanges(_x) {
        return _onDateRangeChanges.apply(this, arguments);
      }

      return onDateRangeChanges;
    }()
    /**
     * for park n shop
     * modify end date time 1hr after start time
     */

  }, {
    key: "updateEndDateTime",
    value: function updateEndDateTime(newVal, oldVal) {
      var nextStartDateTime = this.helper.get(newVal, '0', null);
      var nextStartDate = null;

      if (!this.helper.isUndefined(nextStartDateTime)) {
        nextStartDate = nextStartDateTime.substring(0, 10);
      }

      var nextStartTime = null;

      if (!this.helper.isUndefined(nextStartDateTime)) {
        nextStartTime = nextStartDateTime.substring(11);
      }

      var nextEndDateTime = this.helper.get(newVal, '1', null);
      var nextEndDate = null;

      if (!this.helper.isUndefined(nextEndDateTime)) {
        nextEndDate = nextEndDateTime.substring(0, 10);
      }

      var nextEndTime = null;

      if (!this.helper.isUndefined(nextEndDateTime)) {
        nextEndTime = nextEndDateTime.substring(11);
      }

      if (this.helper.isUndefined(nextStartTime)) {
        return;
      }

      var prevStartDateTime = this.helper.get(oldVal, '0', null);
      var prevStartDate = null;

      if (!this.helper.isUndefined(prevStartDateTime)) {
        prevStartDate = prevStartDateTime.substring(0, 10);
      }

      var prevStartTime = null;

      if (!this.helper.isUndefined(prevStartDateTime)) {
        prevStartTime = prevStartDateTime.substring(11);
      }

      var prevEndDateTime = this.helper.get(oldVal, '1', null);
      var prevEndDate = null;

      if (!this.helper.isUndefined(prevEndDateTime)) {
        prevEndDate = prevEndDateTime.substring(0, 10);
      }

      var prevEndTime = null;

      if (!this.helper.isUndefined(prevEndDateTime)) {
        prevEndTime = prevEndDateTime.substring(11);
      }

      if (nextStartTime === prevStartTime && nextEndTime === prevEndTime && (nextStartDate !== prevStartDate || nextEndDate !== prevEndDate)) {
        return;
      }

      if (!this.helper.isUndefined(nextStartDateTime) && !this.helper.isUndefined(prevStartDateTime) && nextStartDateTime !== prevStartDateTime && ( // nextStartTime !== prevStartTime &&
      nextEndTime === prevEndTime || nextStartTime === nextEndTime)) {
        var nextTime = (0, _moment.default)(nextStartDateTime).add(1, 'hour').format('HH:mm:ss');
        this.$dateRange = [nextStartDateTime, "".concat(nextEndDateTime.substring(0, 10), " ").concat(nextTime)];
      }
    }
  }]);
  return LMDOrderDateRangeComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileV.LastMileDeliveryMixin, _translation.TranslationMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDOrderDateRangeComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$dateRange')], LMDOrderDateRangeComponent.prototype, "handleDateRangeChange", null);
LMDOrderDateRangeComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderDateRangeComponent',
  components: {
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip
  }
})], LMDOrderDateRangeComponent);
var _default = LMDOrderDateRangeComponent;
exports.default = _default;